export const types = {
    COMPONENT: 'COMPONENT',
    WIDTH: 'WIDTH',
    HEIGHT: 'HEIGHT',
    COLS: 'COLS',
    EXTERN: 'EXTERN',
  }
  
  export const OFFSET_X = 2
  export const OFFSET_Y = 1
  
  // grid -> layout
  export const translateGridToLayout = (grid, cols) => {
  
    const components = grid.components.map((comp,i) => ({
      ...comp,
      type: types.COMPONENT,
      i: `${types.COMPONENT}-${i}`
    }))
  
    const widths = grid.widths.map((width, i) => ({
      type: types.WIDTH,
      w:1,
      h:1,
      y: 0,
      x: i+OFFSET_X,
      static: true,
      i: `${types.WIDTH}-${i}`,
      name: width
    }))
  
    const heights = grid.heights.map((height, i) => ({
      type: types.HEIGHT,
      w:1,
      h:1, 
      y: i+OFFSET_Y,
      x: 1,
      i: `${types.HEIGHT}-${i}`,
      static: true,
      name: height
    }))
  
    const buffer = grid.buffer.map((component,i) => ({
      w:1,
      h:1,
      x:0,
      y:i+1,
      component: component,
      type: types.COMPONENT,
      i: `buffer-${i}`
    }))
  
    const result = [
      {x:1, y:0, w:1, h:1, i:'cols', static:true, name:'cols', type:types.COLS  },
      {x:0, y:0, w:1, h:1, i:'extern', static:true, name:'buffer', type:types.EXTERN  },
      ...components,
      ...widths,
      ...heights,
      ...buffer
    ]
    return updateHeights(result)
  }
  // layout -> grid
  export const translateLayoutToGrid = layout => {
    const components = layout
      .filter(comp => comp.type === types.COMPONENT)
      .filter(comp => comp.x !== 0)
  
    const widths = layout
      .filter(comp => comp.type === types.WIDTH)
      .map(comp => comp.name)
  
    const heights = layout
      .filter(comp => comp.type === types.HEIGHT)
      .map(comp => comp.name)
  
    const buffer = layout
      .filter(comp => comp.type === types.COMPONENT)
      .filter(comp => comp.x === 0)
      .map(comp => comp.component)
  
    return { widths, heights, components, buffer }
  }
  
  export const updateLayout = (layout, nativeLayout) => {
    const dict = nativeLayout.reduce((p,n) => Object.assign(p, {[n.i]: n}), {})
    const get = (comp, prop) => dict[comp.i][prop]
    const result = layout
      .map(comp => ({...comp, x:get(comp, 'x'), y:get(comp, 'y'), w:get(comp, 'w'), h:get(comp, 'h')}))
    return updateHeights(result)
  }
  
  
  // layout -> layout
  const updateHeights = layout => {
    const height = layout
      .filter(comp => comp.type === types.COMPONENT)
      .filter(comp => comp.x >= 2)
      .reduce((p,n) => {
        const h = n.h+n.y-OFFSET_Y
        return h > p ? h : p
      }, 0)
  
    let heightComponents = layout.filter(comp => comp.type === types.HEIGHT)
  
    while(heightComponents.length < height){
      heightComponents.push({
        type: types.HEIGHT,
        w:1,
        h:1, 
        y: heightComponents.length+OFFSET_Y,
        x: 1,
        i: `${types.HEIGHT}-${heightComponents.length}`,
        static: true,
        name: 'auto'
      })
    }
    while(heightComponents.length > height){
      heightComponents = heightComponents.slice(0, -1)
    }
  
    return [
      ...layout.filter(comp => comp.type !== types.HEIGHT),
      ...heightComponents
    ]
  }
  
  // (layout, col) -> layout
  export const updateWidths = (layout, col) => {
    const removedComponents = layout
      .filter(comp => (comp.w+comp.x) > col)
      .filter(comp => comp.type !== types.WIDTH)
    const bufferSize = layout.filter(comp => comp.x === 0).length
    
    let widths = layout.filter(comp => comp.type === types.WIDTH)
    if(widths.length+OFFSET_X > col){ widths = widths.slice(0, -1) }
    if(widths.length+OFFSET_X < col){
      widths.push({ type: types.WIDTH, w:1, h:1, y: 0, x: widths.length+OFFSET_X, static: true, i: `${types.WIDTH}-${widths.length}`, name: '1fr' })
    }
    
    const remainingBlocks = layout
      .filter(a => !removedComponents.find(b => b === a))
      .filter(comp => comp.type !== types.WIDTH)
  
    return [
      ...remainingBlocks,
      ...widths,
      ...removedComponents
        .filter(comp => !comp.wasRemoved)
        .map((comp,i) => ({...comp, w:1, h:1, x:0, y: i+bufferSize}))
    ]
  }

  export const updateLabel = (layout, component, newLabel) => {
    const newComponent = { ...component, name: newLabel }
    const replaceIndex = layout.findIndex(comp => comp === component)
    const result = [...layout]
    result[replaceIndex] = newComponent
    return result
  }
  
  export const removeComponent = (layout, component) => {
    return layout.filter(row => row.component !== component)
  }


// WEBPACK FOOTER //
// ./src/utils/grid.js